var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('button',{staticClass:"btn",class:[_vm.inputValue == 1?'btn-primary':'btn-outline-primary'],on:{"click":function($event){return _vm.redirectUser()}}},[_vm._v("حالت ادمین ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }